/**
 * 404-Seite · minimal, HypeFly-Typografie.
 * Wird via Wildcard-Route `path="*"` erreicht.
 *
 * Wichtig: Der HTTP-Statuscode bleibt 200, weil React im Client rendert.
 * Die 404-Semantik ist über `<meta name="robots" content="noindex">`
 * und ein `data-testid="not-found-page"` deutlich gemacht, sodass Crawler
 * die Seite nicht indexieren und automatisierte Tests sie eindeutig
 * identifizieren können.
 */
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import HFHeader from "@/components/HFHeader";
import HFFooter from "@/components/HFFooter";
import { Container } from "@/components/ui-hf";

export default function NotFoundPage() {
    return (
        <div
            data-testid="not-found-page"
            style={{ background: "hsl(var(--hf-bg))", color: "hsl(var(--hf-ink))", minHeight: "100vh", display: "flex", flexDirection: "column" }}
        >
            <Helmet>
                <title>404 — Seite nicht gefunden · HypeFly</title>
                <meta name="robots" content="noindex, nofollow" />
                <meta name="prerender-status-code" content="404" />
            </Helmet>
            <HFHeader />
            <main
                id="main-content"
                className="flex-1 flex items-center"
                style={{ paddingTop: "6rem", paddingBottom: "6rem" }}
            >
                <Container>
                    <div className="max-w-2xl">
                        <div className="hf-eyebrow" data-testid="not-found-eyebrow">Fehler 404</div>
                        <h1
                            className="font-display text-5xl md:text-6xl lg:text-7xl leading-tight mt-3"
                            data-testid="not-found-title"
                        >
                            Diese Seite existiert nicht.
                        </h1>
                        <p
                            className="mt-6 text-base md:text-lg"
                            style={{ color: "hsl(var(--hf-muted))" }}
                            data-testid="not-found-lead"
                        >
                            Der aufgerufene Pfad ist nicht (mehr) Teil dieser Website. Möglicherweise wurde er entfernt oder umbenannt.
                        </p>
                        <div className="mt-8 flex flex-wrap gap-4" data-testid="not-found-actions">
                            <Link
                                to="/"
                                data-testid="not-found-home-link"
                                className="inline-flex items-center gap-2 px-6 py-3 rounded-sm font-medium tracking-wide transition-colors"
                                style={{ background: "hsl(var(--hf-ink))", color: "hsl(var(--hf-bg))" }}
                            >
                                Zur Startseite →
                            </Link>
                            <Link
                                to="/bdv-kontakt"
                                data-testid="not-found-contact-link"
                                className="inline-flex items-center gap-2 px-6 py-3 rounded-sm font-medium tracking-wide transition-colors"
                                style={{ border: "1px solid hsl(var(--hf-line))", color: "hsl(var(--hf-ink))" }}
                            >
                                Kontakt aufnehmen
                            </Link>
                        </div>
                    </div>
                </Container>
            </main>
            <HFFooter />
        </div>
    );
}
